import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';





import FormLabel from '@mui/material/FormLabel';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import NativeSelect from '@mui/material/NativeSelect';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormGroup from '@mui/material/FormGroup';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Checkbox from '@mui/material/Checkbox';
import Radio, { RadioProps } from '@mui/material/Radio';
import { styled } from '@mui/material/styles';


   const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});


 export default class PromotionForm extends Component {

   constructor(props) {
      super(props);
	  var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
          this.state = {PrtypeData:[],pr_maxamount:'',pr_type:'',type:'',redirect: false,pr_id:0,erropen: false,open: false,
     promodata:[], logredirect:false,pr_startdate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
	 errormessage:" ",erropen:false,pr_title:'',pr_code:'',pr_description:'',pr_startdate:'',pr_enddate:'',pr_enddate1:'',classtype:[],classtype1:false,classtype6:false,classtype2:false,classtype3:false,classtype4:false,classtype5:false,
	     submitbtn:"Submit" ,btndisabled:false,pr_value:'',pr_classtype:'',selectedValue:0,pr_file:'',previcons:'',
      
   }
   }
   
   myChangeHandler = (event) => {
	   const re = /^[0-9]+$/;
  let nam = event.target.name;
  let val = event.target.value;
    
  if(nam=="pr_value" || nam=="pr_maxamount" )
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	  }	  
  }
  else{
  this.setState({[nam]: val});
  }
  
} 
	  
	  
	  onloadgetdate()
{  axios.post(Serverurl+'ajaxpromotion.php?action=curdate')
  .then(resp => { 
    if(resp.data!==""){
		var str=resp.data;
				 var month="";
 var date1 = new Date(str);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}  
		 this.setState({pr_startdate:str,pr_startdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),pr_enddate:str,pr_enddate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()});
	}
	
  });
	
}
	 
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
  
 
   getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
 
 
 
   componentWillMount() {
  
	document.title = "AthaYog Living - Promotions";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
		 
		  this.onloadgetdate();
	 let search = window.location.href;
	 let Prodid = this.getParameterByName('Prid',search);
	if(Prodid!==null)
	{
this.PromotionGetData(Prodid);

	}
		
}





 PromotionGetData(Prodid) {
	

	  
	   axios.get(Serverurl+'ajaxpromotion.php?action=getall&pr_id='+Prodid)
  .then(resp => {  
		
    if(resp.data.length>0){
		

	if(resp.data[0].pr_classtype!="")
	{
		let strarrclass=[],classtype1=false,classtype2=false,classtype3=false,classtype4=false,classtype5=false,classtype6=false;
	//var strarr=resp.data[0].pr_classtype.split(',');
	
	/* var subnewRow = strarr.map((rowssub, j) => { 
	 strarrclass.push(rowssub[0]);
	 
	 if(rowssub[0]=="1")
	 {
		 classtype1=true
	 }
	else if(rowssub[0]=="2")
	 {
		 classtype2=true
	 } else if(rowssub[0]=="3")
	 {
		 classtype3=true
	 }
	 else if(rowssub[0]=="4")
	 {
		 classtype4=true
	 }
	  else if(rowssub[0]=="5")
	 {
		 classtype5=true
	 }
	 else if(rowssub[0]=="6")
	 {
		 classtype6=true
	 }
	 
	 });*/

	 //this.setState({classtype:resp.data[0].pr_classtype,classtype1:classtype1,classtype2:classtype2,classtype3:classtype3,classtype4:classtype4,classtype5:classtype5,classtype6:classtype6})
	 }
	 
	 
	 	let strcoup=resp.data[0].pr_code;
		
		let strcoupval="";
		if(strcoup === "")
		{
			
			strcoupval = "2";
			
		}
		else
			
		
		{
			strcoupval= "1";
			
			
		} 
	 
	 
	 
    this.setState({ 
     classtype1:resp.data[0].pr_classtype,
     pr_id:resp.data[0].pr_id,
 pr_title:resp.data[0].pr_title,
pr_code:resp.data[0].pr_code,
                pr_description:resp.data[0].pr_description,
 			  pr_startdate: resp.data[0].pr_startdate,  
			  pr_enddate: resp.data[0].pr_enddate,  
			 pr_startdate1: resp.data[0].pr_startdate,  
			  pr_enddate1: resp.data[0].pr_enddate, 
			  pr_value: resp.data[0].pr_value,  
			  pr_maxamount: resp.data[0].pr_maxamount,  
			  pr_type: resp.data[0].pr_type,  
			  previcons: resp.data[0].pr_file,  
			  selectedValue:strcoupval,  
		
			 
	
  
	

    
    },()=>{});

  
	}else{
	 this.setState({  
	  pr_id:0,
	  pr_title:'',
		pr_code:'',
	
		
		pr_description:'',
		pr_value:'',
		pr_maxamount:'',
		pr_type:'',
		pr_classtype:'',
	
	 
	  }); 
 
  
    }
});
	  
 }
handdateChanges = (date) => {
	
	  var month="",month1="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}  

var dateend = new Date(date);

	dateend.setDate(dateend.getDate() + 1); 
	
	 if((dateend.getMonth() + 1)<10)
	 {
		month1="0"+ (dateend.getMonth() + 1)		 
	 }else{month1=(dateend.getMonth() + 1)}  
     this.setState({ pr_startdate:dayjs(date),pr_enddate:dayjs(date).add(1, 'day'),
pr_startdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
pr_enddate1:dateend.getFullYear() + '-' + month1 + '-' +dateend.getDate()
	 })
	
	
  }

handenddateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ pr_enddate:dayjs(date),
pr_enddate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
  
   	  
	   handleSubmit= (event) => {
	   
    

	let pr_id = this.state.pr_id;
	 let pr_title=this.state.pr_title;
    let pr_code = this.state.pr_code;
	let pr_description = this.state.pr_description;
    let pr_startdate = this.state.pr_startdate1;
	 let pr_enddate = this.state.pr_enddate1;

	 let pr_value = this.state.pr_value;
	 let pr_maxamount = this.state.pr_maxamount;
	 let pr_type = this.state.pr_type;
	 let pr_classtype = this.state.pr_classtype;




if(pr_title==="")
{
	
	this.setState({errormessage:"Please Enter Title",erropen:true});
		 window.scrollTo({
          top: 0
      })
	return false;
}



if(pr_startdate==="")
{
	this.setState({errormessage:"Please Enter Start Date.",erropen:true});
		 window.scrollTo({
          top: 0
      })
	return false;
} 


if(pr_enddate==="")
{
	this.setState({errormessage:"Please Enter End Date",erropen:true});
	return false;
} 


if(pr_type==="")
{
	this.setState({errormessage:"Please Select type.",erropen:true});
		 window.scrollTo({
          top: 0
      })
	return false;
}
if(pr_value==="")
{
	this.setState({errormessage:"Please Enter Extend No. of days",erropen:true});
	return false;
} 
if(pr_maxamount==="")
{
	this.setState({errormessage:"Please Enter Maximum Amount.",erropen:true});
		 window.scrollTo({
          top: 0
      })
	return false;
}
if(pr_description==="")
{
	this.setState({errormessage:"Please Enter Description.",erropen:true});
		 window.scrollTo({
          top: 0
      })
	return false;
}
/*
let strsep="",strclass="";
 var subnewRow = this.state.classtype.map((rowssub, j) => { 

strclass=strclass+strsep+rowssub[0];
strsep=",";
 });*/


	 var formData = new FormData();

	  
	
	 formData.append('action','insertorupdate')
	 
	 
				
				if(pr_id===0){
					formData.append('pr_id',"0")
					}
				else{
					
					formData.append('pr_id',pr_id)
				
				}
    formData.append('pr_title',pr_title)
	 formData.append('pr_code',pr_code)
	 formData.append('pr_description',pr_description)
	formData.append('pr_startdate',pr_startdate)
	   formData.append('pr_enddate',pr_enddate)
	   
	   formData.append('pr_value',pr_value)
	   formData.append('pr_maxamount',pr_maxamount)
	   formData.append('pr_type',pr_type)
	   formData.append('pr_classtype',this.state.classtype1)

	  		
	  formData.append('userid',localStorage.getItem("AYLuserid"))
	  
	  
	  	if(this.state.pr_file!=="")
	  {
		
		for (const key of Object.keys(this.state.pr_file)) {
            formData.append('Filedata', this.state.pr_file[key])
        }
 	
	   formData.append('pr_file','1')	
	   		
	  }else
	  {
		 formData.append('pr_file',this.state.previcons)	  
	  }	
	  
	  
	  
 axios.post(Serverurl+"ajaxpromotion.php", formData, {
        }).then(res => {
				if(res.data!=-1)
					{
						
					let strreturn=res.data;
					strreturn=strreturn;
					
					
					
						this.setState({redirect:true,pagename:'/Adminpromotion'});
					
					//this.setState({open:false,btnsavedisbaled:false,btnsavetxt:'Save',});
				
						
							
							
						}
	   });
	  
    				
					
				}
  
					
  
  
	  
	  
	  
	  
	handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
  
  
  
  
  
  /*
    onChangeClass = (event: React.ChangeEvent<HTMLInputElement>) => {
	let strclasstype=[...this.state.classtype,event.target.name]
	let classtype1=false,classtype2=false,classtype3=false,classtype4=false,classtype5=false, classtype6=false;
 if (this.state.classtype.includes(event.target.name)) {
	
      strclasstype = strclasstype.filter(day => day !== event.target.name);
	  
	   
    }
		
	 var subnewRow = strclasstype.map((rowssub, j) => { 
	
	 if(rowssub[0]=="1")
	 {
		 classtype1=true
	 }
	else if(rowssub[0]=="2")
	 {
		 classtype2=true
	 } else if(rowssub[0]=="3")
	 {
		 classtype3=true
	 }
	 else if(rowssub[0]=="4")
	 {
		 classtype4=true
	 }
	  else if(rowssub[0]=="5")
	 {
		 classtype5=true
	 }
	  else if(rowssub[0]=="6")
	 {
		 classtype6=true
	 }
	 });

	 this.setState({classtype:strclasstype,classtype1:classtype1,classtype2:classtype2,classtype3:classtype3,classtype4:classtype4,classtype5:classtype5,classtype6:classtype6},()=>{
			 
			
		 })
 
		
	}*/
	
	   handleChange = (event) => {
	 const { selectedValue } = this.state;

    this.setState({selectedValue:event.target.value},()=>{
	  if(this.state.selectedValue=== "1") {
		this.generateRandomString();
	  }
	  else{
		  
		    this.setState({pr_code:''});
	  }
	 
	});
  };
  
  onChangeClass = (event) => {
	 const { classtype } = this.state;

    this.setState({classtype1:event.target.value},()=>{
	  
	 
	});
  };


  generateRandomString = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=';
    let randomString = '';
    for (let i = 0; i < 6; i++) {
     const randomIndex = Math.floor(Math.random() * characters.length);
	 randomString += characters[randomIndex];
	  
    }
	
    this.setState({pr_code:randomString},()=>{
		
	
	});
	
	
  };
	  
	  
	  
	  
onFileChange=(e) =>{
	   
	 let imageFile = e.target.files[0];
	 if (!imageFile) {

  
	 this.setState({errormessage:"Please select image",erropen:true});
	  window.scrollTo({        top: 0     });
     return false;
     }
 
   if (!imageFile.name.match(/\.(jpg|jpeg|png|pdf)$/)) {

  this.setState({errormessage:"Please select valid file (jpg,jpeg,png,pdf)",erropen:true});
	 window.scrollTo({        top: 0     });
    return false;
  }else{    this.setState({pr_file:e.target.files})}
       
	   
	  
    }
	  
	  
	  
render() { 
  
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  
 
  
  return (
  

		<React.Fragment>
	
<div className="boxheading"><h1>Coupon Code</h1></div>
<div className="addandbacbtn"><a href='/Adminpromotion' >Back</a></div>

<div className="clear"></div>
		


 <p>   <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	
<div className="formmain">

<ul>
  
<li>  
		 <p><span className="validation">*</span> Title</p>
		 
		<p>
		<TextField name="pr_title" 
	   onChange={this.myChangeHandler} 
	   fullWidth 	 inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   value={this.state.pr_title}
                          /></p>
 
 </li>
 




    <li>
			  <p>Coupon Code</p>
			  <p>
			   <FormControl className="pr_code">
          <RadioGroup
            value={this.state.selectedValue}
            onChange={this.handleChange}
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 18,
                color: "green",
              },
            }}
          >
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="With coupon Code"
            />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="without coupon Code"
            />
          </RadioGroup>
        </FormControl>
		</p>
		</li>



  {this.state.selectedValue === "1" &&(
<li>   <p><span className="validation">*</span> Code</p>
		<p> <TextField name="pr_code" 
	   onChange={this.myChangeHandler} 
	   fullWidth 	 inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   value={this.state.pr_code}
	
                          /></p></li>


  )}

	  
<li>	  <p><span className="validation">*</span> Start Date</p>
		  
		  <p > 
		  <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.pr_startdate) } className="txtbox"
className="txtbox" minDate={dayjs(Date.now()) }
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
		  
		
		  </p></li>
		  
		  
	
		  
<li>  
		  <p><span className="validation">*</span> End Date</p>
		 <p>  <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker className="txtbox"
value= {dayjs(this.state.pr_enddate) }
className="txtbox" minDate={dayjs(Date.now()) }
    onChange={this.handenddateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
		  </p></li>
		 
		
		<li>
	 <p>Type</p>
	<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler} className="txtbox"
          id="pr_type"
		   value={this.state.pr_type} inputProps={{tabIndex: "2"}}
		  name="pr_type"
		
        >
	
	<option value="">Select Type</option>
      
		   <option value={1}>Rupees</option>
          <option value={2}>Percentage</option>
 <option value={3}>Days</option>


        </Select>

		</FormControl>
		</p>
	</li>	
		
		
				  
<li>  
		  <p><span className="validation">*</span>Value</p>
		 <p> <TextField name="pr_value" 
	   onChange={this.myChangeHandler} 
	   fullWidth 	 inputProps={{tabIndex: "5",maxLength:6}} className="txtbox"
	   value={this.state.pr_value}
			 
			 
                          />
		  </p></li>
		 

		<li>  
		  <p><span className="validation">*</span>Maximum Amount</p>
		 <p> <TextField name="pr_maxamount" 
	   onChange={this.myChangeHandler} 
	   fullWidth 	 inputProps={{tabIndex: "5",maxLength:6}} className="txtbox"
	   value={this.state.pr_maxamount}
			 
			 
                          />
		  </p> </li>
		  
		   <li>
	
  <FormControl>
      <FormLabel id="demo-row-radio-buttons-group-label">Select Class Type</FormLabel>
      <RadioGroup
        row  value={this.state.classtype1}
            onChange={this.onChangeClass}
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
      >
        <FormControlLabel value="1" control={<Radio />} label="Personal Training at Home" />
        <FormControlLabel value="2" control={<Radio />} label="Personal Training in Studi" />
        <FormControlLabel value="3" control={<Radio />} label="Group" />
		        <FormControlLabel value="4" control={<Radio />} label="Prenatal" />
			  <FormControlLabel value="5" control={<Radio />} label="Product" />
		  <FormControlLabel value="6" control={<Radio />} label="Personal Training Online" />
       
      </RadioGroup>
    </FormControl>
	{ /*  <Checkbox id="classtype1" name="1" onChange={this.onChangeClass} checked={this.state.classtype1} /> Personal Training at Home
        <Checkbox id="classtype2" name="2" onChange={this.onChangeClass}  checked={this.state.classtype2}/> Personal Training in Studio<br/>
       <Checkbox id="classtype3" name="3" onChange={this.onChangeClass} checked={this.state.classtype3}/> Group
        <Checkbox  id="classtype4" name="4" onChange={this.onChangeClass} checked={this.state.classtype4}/> Prenatal
		<Checkbox  id="classtype5" name="5" onChange={this.onChangeClass} checked={this.state.classtype5}/> Product
		<Checkbox  id="classtype6" name="6" onChange={this.onChangeClass} checked={this.state.classtype6}/> Personal Training Online
	*/}  </li>
		 


		
		

 

		
	
	
			
<li>
	  <p>Description: </p> <p > 
		  
	 <TextField name="pr_description" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
          rows={4}
	   value={this.state.pr_description} className="txtbox"
			 
			  
			  inputProps={{tabIndex: "6"}} 
	   InputLabelProps={{ shrink: true }}
                          />
		  </p>
	</li>
	
	
	 <li><p>Upload File:</p><p> 
		    
		  	<Button component="label"  name="pr_file"    onChange={this.onFileChange}    variant="contained"    startIcon={<CloudUploadIcon />}>
	
		Uplaod File
		<VisuallyHiddenInput type="file"  multiple /></Button>
		
		  </p>  {this.state.previcons!=="" &&(<a target="_blank" href={Serverurl + 'uploads/' + this.state.previcons}> View</a>)}</li>
	
	
	
	
	</ul>
		</div>				
		         <p className="aligncentr"> 
		  <Button variant="contained" className="frmSecondarybtn" onClick={this.handleSubmit}>
   Submit
</Button></p>



 </React.Fragment>
  );
  }
	  
	  
 
	  
	  
	  
	   }